export const CARD = 'card'
